import { render, staticRenderFns } from "./warehouseReceiptRecord.vue?vue&type=template&id=ba8ff4de&scoped=true"
import script from "./warehouseReceiptRecord.vue?vue&type=script&lang=js"
export * from "./warehouseReceiptRecord.vue?vue&type=script&lang=js"
import style0 from "./warehouseReceiptRecord.vue?vue&type=style&index=0&id=ba8ff4de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8ff4de",
  null
  
)

export default component.exports